// extracted by mini-css-extract-plugin
export default {"modal":"CellWithModal_modal__a5kDR","cell":"CellWithModal_cell__n4cvU"};